abstract class BaseItemConfig {
    $type: string;
    classTypeNameForDotNet: string;
    isDirty: boolean;
    get isReportConfig() { return false; }
    get allowEditDrilldown() { return this.isReportConfig; }
    
    constructor(data: any) {
        this.$type = data.$type;
    }

    abstract get allowDetailTab(): boolean;

    updateReportAfterSaving(data) { }

    saveAnalyzeByOrGroupBy(tabOrWidget: ITabOrWidget, drilldown: Drilldown, isSaveGroupBy = false, isDrilldown?: boolean, newDrilldownTabName: string = null) {
        this.saveChangeAnalyzeByOrGroupBy(tabOrWidget, drilldown.id, 0, isSaveGroupBy, isDrilldown, newDrilldownTabName);
    }
    protected saveChangeAnalyzeByOrGroupBy(tabOrWidget: ITabOrWidget, templateId: number, groupReportId: number, isSaveGroupBy = false, isDrilldown?: boolean, newDrilldownTabName: string = null) {
        let self = this;
        let submitObject = tabOrWidget.getBaseSubmitObject();
        submitObject.newReportId = templateId;
        submitObject.groupReportId = groupReportId;
        if (isDrilldown) {
            submitObject.drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
        }

        let analyzeOrGroupText = isSaveGroupBy ? "Group" : "Analyze";

        let o = {
            url: urlConfigs.workBook + (isSaveGroupBy ? "ChangeGroupBy" : "ChangeReport"),
            data: submitObject,
            dataType: "json",
            async: true,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            DevExpress.ui.notify(`${analyzeOrGroupText} By changed.`);

            self.updateReportAfterSaving(data);

            let refresh = () => {
                if (isDrilldown) {
                    tabOrWidget.drilldownManager.refresh();
                }
                else {
                    tabOrWidget.refresh();
                }

                Ir.Components.ReportDesigner.ReportDesigner.reload(tabOrWidget);
            }

            if (isSaveGroupBy) {
                refresh();
            }
            else {
                self.updateDrilldownListRemovingTemplateId(tabOrWidget, refresh);
            }

            if (isDrilldown && newDrilldownTabName) {
                tabOrWidget.drilldownManager.getActiveDrillViewItem().tabName(newDrilldownTabName);
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to change ${analyzeOrGroupText} By`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    updateDrilldownListRemovingTemplateId(tabOrWidget: ITabOrWidget, callback: Function = null) { }
}